import { pxToRem } from '../../../../utils';
export var chatMessageDetailsVariables = function chatMessageDetailsVariables(siteVars) {
  return {
    detailsColor: siteVars.colors.grey[350],
    detailsHoverColor: siteVars.colors.grey[500],
    detailsColorMine: siteVars.colors.grey[500],
    detailsHoverColorMine: siteVars.colors.grey[500],
    detailsFontSize: siteVars.fontSizes.small,
    detailsMargin: pxToRem(12)
  };
};
//# sourceMappingURL=chatMessageDetailsVariables.js.map
